import { useShallow } from 'zustand/react/shallow';

import { DrawerManagerContextType } from './drawer-manager.model';
import { useDrawerStore } from './drawer-manager.store';

const useDrawer = (): DrawerManagerContextType =>
  useDrawerStore(
    useShallow(({ open, close, closeAll, isOpen }) => ({
      open,
      close,
      closeAll,
      isOpen,
    })),
  );

export { useDrawer };
